import React from "react";
import ParticiPant from "./components/ParticiPant";
import ParticiPantSetting from "./components/ParticiPantSetting";
import { ReactComponent as PluginSvg } from "@assets/icons/participant_setting.svg";
import { getLocale } from '@utils/util';

export default () => {
  const messages = getLocale();
  return {
    name: 'participant', // 插件名，不能包含空格,空格用-代替
    // group: ElementGroup.CUSTOM, // 插件所在组，默认为ElementGroup.CUSTOM
    // target: ["column", "row", "form"], // 插件所在目标层级，默认为["column", "row", "form"]
    title: messages['PAGEBUIDER_ELEMENT_FORM_PARTICIPANT'], // 插件标题
    toolBarPreview: <PluginSvg />, // 插件展示图标，不传则展示文字
    data: { // 插件初始化数据
      settings: {
        width: {
          value: "100%"
        },
      }, // 插件样式属性
      formItemSettings: {
        allowClear: true,
        bordered: true,
        defaultValue: {
          partyName: '波波维奇,小明,保罗乔治',
          value: [{
            partyId: '002',
            partyName: '波波维奇',
            partyType: '教练',
          },
          {
            partyId: '003',
            partyName: '小明',
            partyType: '普通工作人员',
          },
          {
            partyId: '005',
            partyName: '保罗乔治',
            partyType: '运动员',
          }],
        },
        // value: {
          // partyName: '波波维奇,小明,保罗乔治',
          // value: [{
          //   partyId: '002',
          //   partyName: '波波维奇',
          //   partyType: '教练',
          // },
          // {
          //   partyId: '003',
          //   partyName: '小明',
          //   partyType: '普通工作人员',
          // },
          // {
          //   partyId: '005',
          //   partyName: '保罗乔治',
          //   partyType: '运动员',
          // }],
        // },
        dataTextField: 'partyName',
        dataValueField: 'value',
        inputProps: {
        },
        modalProps: {
          title: '选择人员',
          render: 'https://fish.iwhalecloud.com/remote-components/participant-table.js',
          onOk: () => { },
          maskClosable: false, // 默认点击蒙层是否允许关闭 不关闭
        },
      },
      formSettings: {
        label: messages['PAGEBUIDER_ELEMENT_FORM_PARTICIPANT'],
      },
    },
    pluginComponent: ParticiPant, // 插件渲染组件
    pluginSettingComponent: ParticiPantSetting, // 插件设置项组件
  }
}
